@if (taDetails()?.hasAttachments) {
  <i class="fa-regular fa-paperclip text-surface-600 text-sm"
     data-testid="attachment-indicator"></i>
}
